import React, { useContext, useEffect, useState } from 'react';
import { Timeout, formattedDate } from '../../functions/functions';
import { FormDataAdsInfoContext, ShowAdsInfoContext } from './types';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import InputsAdsInfo from './forms/InputsAdsInfo';
import { useDispatch } from 'react-redux';
import { EditAdsInfoApi } from '../../redux/adsinfo/adsInfoApiCalls';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';

interface props {
  modal: boolean, 
  toggle: any
}

const EditAdsInfoModal: React.FC<props> = ({ modal, toggle }) => {
  const [title, setTitle] = useState("")
  const [company, setCompany] = useState("")
  const [finishDate, setFinishDate] = useState<string>(formattedDate(new Date().toString()))
  const [loading, setLoading] = useState(false)

  const [images, setImages] = useState<File[] | any>(null)
  
  const dispatch: any = useDispatch()

  const [errors, setErrors] = useState<string[]>([])

  const { setShowSuccessMsg, selectedAdsInfo } = useContext(ShowAdsInfoContext)

  useEffect(() => {
    setTitle(selectedAdsInfo.title)
    setCompany(selectedAdsInfo.company)
    setFinishDate(formattedDate(selectedAdsInfo.finishDate))
  }, [selectedAdsInfo])

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    try {
      const formData: any = new FormData()
      formData.append("title", title)
      formData.append("company", company)
      formData.append("finishDate", finishDate)

      const response: any = await dispatch(EditAdsInfoApi(selectedAdsInfo._id, formData))
      if(response === true) {
        toggle()
        setShowSuccessMsg(true)
        setTimeout(() => setShowSuccessMsg(false), Timeout)
        setTitle("")
        setCompany("")
        setFinishDate(formattedDate(new Date().toString()))
      } else {
        setErrors(response)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormDataAdsInfoContext.Provider value={{
      title, setTitle,
      company, setCompany,
      finishDate, setFinishDate,
      images, setImages
    }}>
    {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                    encType="multipart/form-data"                  
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <InputsAdsInfo />
                    <ButtonsForm loading={loading} typeBtn='Modifier' toggle={toggle} />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </FormDataAdsInfoContext.Provider>
  );
}

export default EditAdsInfoModal
